export default "__VITE_ASSET__B$_HE7vi__"